import { Card, CircularProgress, Typography } from "@mui/material";
import { useTranslations } from "use-intl";

type Props = {
  count: number;
};

export const OrdersInCreationCard = ({ count }: Props) => {
  const t = useTranslations();

  return (
    <Card
      className="mb-2 flex flex-row items-center gap-2 p-4"
      sx={{
        borderRadius: "var(--radius-3xl)",
      }}
      elevation={0}
    >
      <CircularProgress size={20} />
      <Typography variant="body2">
        {t("reservations.ordersInTheProcessOfCreation", { count })}
      </Typography>
    </Card>
  );
};
